import { Fragment, type ReactNode } from "react";

// Splits a (translated) string on the [[...]] accent marker and wraps the marked
// phrase in the emphasis underline. Lets translators reorder the accent freely.
export function renderAccent(text: string): ReactNode {
  return text.split(/\[\[(.+?)\]\]/g).map((part, index) =>
    index % 2 === 1 ? (
      <span key={index} className="emphasis-underline">
        {part}
      </span>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    ),
  );
}
